import { ApolloCache, FetchResult } from '@apollo/client';
import {
  type GetPlayerProfileQuery,
  type UpsertFollowerConnectionMutation,
} from 'types/generated/client';
import { GET_PLAYER_PROFILE } from './graphql';

/**
 * Mirrors `gql/cache/updateCacheGetUserProfileFollowing` for this screen's query.
 * Apollo won't see a brand-new follow row unless it's written in, so without this
 * the button snaps back to "Pin to Favorites" once the optimistic response clears.
 */
export const updateCachePlayerProfileFollowing =
  (username: string) =>
  (
    cache: ApolloCache<any>,
    {
      data,
    }: Omit<
      FetchResult<UpsertFollowerConnectionMutation, Record<string, any>, Record<string, any>>,
      'context'
    >,
  ) => {
    const newFollow = data?.insertUserFollowsOne;
    if (!newFollow) return;

    const variables = {
      username: username.toLowerCase(),
      viewerId: newFollow.followerUserId,
    };

    const read: GetPlayerProfileQuery | null = cache.readQuery({
      query: GET_PLAYER_PROFILE,
      variables,
    });
    if (!read) return;

    cache.writeQuery({
      query: GET_PLAYER_PROFILE,
      variables,
      data: {
        ...read,
        userFollows: [
          newFollow,
          ...(read.userFollows || []).filter(
            (follow) => follow.followedUserId !== newFollow.followedUserId,
          ),
        ],
      },
    });
  };
